import cookie from 'utils/cookie';
import { COOKIE_KEYS } from 'consts/cookieKeys';

export const hasAuth = () => !!cookie.get(COOKIE_KEYS.auth);
